import { Container } from '@mui/material';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Page from '../../../components/Page';
import { useParams } from 'react-router-dom';
import PromoCodeForm from './PromoCodeForm';

const index = () => {
  const params: any = useParams();
  const isAddMode = !params?.id;
  return (
    <Page title={'Promo Code'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={`${isAddMode ? 'Add Promo Code' : 'Edit Promo Code'} `}
          links={[
            { name: 'Dashboard', href: '/' },
            { name: 'Promo Code', href: '/promo-code' },
          ]}
        />
        <PromoCodeForm />
      </Container>
    </Page>
  );
};

export default index;
